module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_06_600M.386ca1dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_06_600M.jpg
// module id = 339
// module chunks = 0